import { post, get, patch, deleted } from 'services';
import routes from './routes';

const BuyerServices = {
  getBuyerIds: async (params) => {
    const data = await get(routes.getBuyerIds, params);
    return data;
  },
  getBuyerIdHistoryLogs: async (params) => {
    const data = await get(routes.getBuyerIdHistoryLogs, params);
    return data;
  },
  createBuyerId: async (obj) => {
    const data = await post(routes.createBuyerId, obj);
    return data;
  },
  createBusinessLocation: async (obj) => {
    const data = await post(routes.createBusinessLocation, obj);
    return data;
  },
  updateBuyerId: async (obj) => {
    const data = await patch(routes.updateBuyerId, obj);
    return data;
  },
  updateBusinessLocation: async (obj) => {
    const data = await patch(routes.updateBusinessLocation, obj);
    return data;
  },
  deleteBuyerId: async (params) => {
    const data = await deleted(routes.deleteBuyerId, params);
    return data;
  },
   createOrganization: async (obj) => {
    const data = await post(routes.createOrganization, obj);
    return data;
  },
   getOrganizationData: async (params) => {
    const data = await get(routes.getOrganizationData, params);
    return data;
  },
   updateOrganization: async (obj) => {
    const data = await patch(routes.updateOrganization, obj);
    return data;
  },
  sendOtpForPasswordVerification: async (obj) => {
    const data = await post(routes.sendOtpForPasswordVerification, obj);
    return data;
  },
   verifyOtp: async (obj) => {
    const data = await post(routes.verifyOtp, obj);
    return data;
  },
   sendOrgOtpForPasswordVerification: async (obj) => {
    const data = await post(routes.sendOrgOtpForPasswordVerification, obj);
    return data;
  },
   verifyOrgOTP: async (obj) => {
    const data = await post(routes.verifyOrgOTP, obj);
    return data;
  },
  getBelongsTo: async (params) => {
    const data = await get(routes.getBelongsTo, params);
    return data;
  }
}

export default BuyerServices